/* eslint-disable no-console */
import {ISelect} from './../../../interface/ISelect';

interface Ifilter {
  mainKey: string;
  filterer: ISelect[];
  subKey: string;
  returnFilterKey: string;
}

interface select {
  value: string;
  label: string;
  [key: string]: string | undefined;
}

export const returnProductFilter = (
  filterer: Ifilter[],
  data: any,
  filterProduct?: {filterKey: string; filterValue: string}
): any => {
  const result: Record<string, select[]> = {};
  const firstReturn: string = filterer?.[0]?.returnFilterKey;
  const firstReturnId = filterer?.[0]?.mainKey;

  filterer.forEach((filter, filterIndex) => {
    const {mainKey, filterer: filters, subKey, returnFilterKey} = filter;
    result[returnFilterKey] = [];

    const subItemId: any[] = [];
    data
      ?.filter((item: any) => {
        return filterProduct?.filterKey && filterProduct.filterValue
          ? item?.[filterProduct?.filterKey] === filterProduct.filterValue
          : true;
      })
      .forEach((item: any) => {
        const itemValue = subKey
          ? (item[mainKey] || []).map((subItem: any) => {
              subItemId.push({...subItem, mainId: item?._id});

              return subItem[subKey];
            })
          : item[mainKey];

        if (Array.isArray(itemValue)) {
          const filteredValues = filters.filter((filter) =>
            itemValue.includes(filter.value)
          );

          if (filteredValues.length > 0) {
            filteredValues.forEach((filteredValue) => {
              const id = subItemId.find((subItem: any) => {
                return (
                  subItem?.[subKey] === filteredValue.value &&
                  item?._id === subItem?.mainId
                );
              })?._id;

              result[returnFilterKey].push({
                value: filterIndex === 0 ? item._id : id,
                label: filteredValue.label as string,
                [firstReturnId]: item._id,
                state: returnFilterKey.startsWith('raw')
                  ? filteredValue.state
                  : '',
                facilityId: filteredValue.value
              });
            });
          }
        } else {
          const filteredValues = filters.filter(
            (filter) => filter.value === itemValue
          );

          if (filteredValues.length > 0) {
            result[returnFilterKey].push({
              value: item._id,
              label: filteredValues[0].label as string,
              [firstReturnId]: item._id,
              state: returnFilterKey.startsWith('product')
                ? filteredValues?.[0].state
                : '',
              facilityId: item[mainKey]
            });
          }
        }
      });
  });

  return {
    ...result,
    [firstReturn]: result?.[firstReturn]?.map((obj) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const {[firstReturnId]: _, ...rest} = obj;

      return rest;
    })
  };
};
